import React, { useState, useEffect } from "react";
import { typeIcons } from "../components/Utils";
import axios from "../axiosConfig";
import Table from "../components/Table";
import { parseDbDate } from "../utils/dates";
import PageTitle from "../components/PageTitle";

const Jobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/jobs/");
      setJobs(res.data || []);
    } catch (err) {
      console.error("Error fetching jobs:", err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    return parseDbDate(dateStr)?.toLocaleDateString("en-GB") ?? dateStr;
  };

  const columns = [
    {
      key: "account",
      header: "Account",
      type: "static",
      sortable: false,
      width: 80,
      render: (value, row) => {
        if (row.account_data) {
          return row.account_data.name_short || row.account_data.name_long;
        }
        return row.account_id ? `Account #${row.account_id}` : "—";
      },
    },
    {
      key: "title",
      header: "Job Name",
      type: "text",
      width: 160,
    },
    {
      key: "stage",
      header: "Stage",
      type: "discrete",
      width: 96,
      render: (value) => value || "—",
    },
    {
      key: "start_date",
      header: "Start Date",
      type: "date",
      width: 96,
      render: (value) => formatDate(value),
    },
  ];

  return (
    <div className="page-layout">
      <PageTitle>{typeIcons["job"]} Jobs</PageTitle>

      <div className="page-content">
        <Table
          data={jobs}
          columns={columns}
          loading={loading}
          emptyMessage="No jobs found."
          onRowClick={(job) => (window.location.href = `/job?id=${job.id}`)}
          defaultSortColumn="start_date"
          defaultSortDirection="desc"
        />
      </div>
    </div>
  );
};

export default Jobs;
